import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class PagePath extends Component {
    constructor(props) {
        super();
        this.parts = props.paths.split(',');
        this.links = props.links ? props.links.split(',') : [];
        this.links = this.links.map((item) => item.replace(/{domain_id}/g, window.info.id));

        const urlParams = new URLSearchParams(window.location.search);

        if (props.custom_path) {
            switch (props.custom_path) {
                case 'discover_entity_tracking': {
                    const entity_name = urlParams.get('entity_name');
                    const language = urlParams.get('language');
                    const country = urlParams.get('country');
                    const base_domain = urlParams.get('base_domain');
                    const collectionName = urlParams.get('collection');

                    const firstPart = `${
                        entity_name ?? collectionName ?? ''
                    } (${country}/${language})`;
                    this.parts.push(firstPart);
                    if (base_domain) {
                        const secondPart = base_domain;
                        this.parts.push(secondPart);
                    }
                    break;
                }
                default:
                    '';
            }
        }
    }

    render() {
        const { t } = this.props;
        const showItem = (item) => t(`${item}`, { defaultValue: item });

        return (
            <div className="page-path">
                <a href="/domains" className="breadcrum-home-btn">
                    <i className="icon-Breadcrumb-button-base"></i>
                </a>
                {this.parts?.map((item, i) => (
                    <React.Fragment key={item}>
                        <i className="icon-chevron-right"></i>
                        {this.links[i] ? (
                            <a href={this.links[i]}>{showItem(item)}</a>
                        ) : (
                            <span>{showItem(item)}</span>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }
}

export default withTranslation()(PagePath);
